import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Login.vue";
import Register from "@/views/tranning/Register.vue";
import TranningList from "@/views/tranning/tranninglist.vue";
import TranningAdd from "@/views/tranning/tranningadd.vue";
import TranningEdit from "@/views/tranning/tranningedit.vue";
import Stock from "@/views/Stock.vue";
import StockCreate from "@/views/StockCreate.vue";
import StockEdit from "@/views/StockEdit.vue";
import Report from "@/views/Report.vue";
import About from "@/views/About.vue";
import Dashboard from "@/views/Dashboard.vue";
import Calendar from "@/views/Calendar.vue";
import notFound from "@/views/notFound.vue";
import testSystem from "@/views/testSystem.vue";
import Employee from "@/views/Employee.vue";
import Customer from "@/views/Customer.vue";
import Config from "@/views/Config.vue";
import RoleConfig from "@/views/RoleConfig.vue";
import GroupMenu from "@/views/GroupMenu.vue";
import Docrunning from "@/views/docrunning.vue";
import SettingGroupMenu from "@/views/SettingGroupMenu.vue";
import MenuDetail from "@/views/MenuDetail.vue";
import SettingMenuDetail from "@/views/SettingMenuDetail.vue";
import SoList from "@/views/SoList.vue";
import SalesOutstanding from "@/views/SalesOutstanding.vue";
import SalesReport from "@/views/SalesReport.vue";
import AddSo from "@/views/AddSo.vue";
import Advancelist from "@/views/Advancelist.vue";
import NewAdvance from "@/views/NewAdvance.vue";
import EditAdvance from "@/views/EditAdvance.vue";
import ApproveAdvance from "@/views/ApproveAdvance.vue";
import ClearAdvancelist from "@/views/ClearAdvancelist.vue";
import ClearAdvanceadd from "@/views/ClearAdvanceAdd.vue";
import ApproveAdvancelist from "@/views/ApproveAdvancelist.vue";
import AccountPendingAdvancelist from "@/views/AccountPendingAdvancelist.vue";
import AccountClearAdvancelist from "@/views/AccountClearAdvancelist.vue";
import AccountReportingAdvancelist from "@/views/AccountReportingAdvancelist.vue";
import AccountPendingAdvance from "@/views/AccountPendingAdvance.vue";
import AccountClearAdvance from "@/views/AccountClearAdvance.vue";
import MyTimeSheet from "@/views/MyTimeSheet.vue";
import SummaryTimeActivityReport from "@/views/SummaryTimeActivityReport.vue";
import ApproveTimeSheet from "@/views/ApproveTimeSheet.vue";
import SummaryReport from "@/views/SummaryReport.vue";
import ClientSummaryReport from "@/views/ClientSummaryReport.vue";
import EmployeeAttendentSummaryReport from "@/views/EmployeeAttendentSummaryReport.vue";
import EmployeeSummaryReport from "@/views/EmployeeSummaryReport.vue";
import AttendantReport from "@/views/AttendantReport.vue";
import PInvoice from "@/views/invoice/PInvoice.vue";
import Invoice from "@/views/invoice/Invoice.vue";
import Receive from "@/views/invoice/Receive.vue";
import AdjustReceive from "@/views/invoice/AdjustReceive.vue";
import ReceiveSelectDocument from "@/views/invoice/ReceiveSelectDocument.vue";
import ReceiveConfirm from "@/views/invoice/ReceiveConfirm.vue";
import ReceiveEdit from "@/views/invoice/ReceiveEdit.vue";
import ReceiveAdjustEdit from "@/views/invoice/ReceiveAdjustEdit.vue";
import InvoiceReport from "@/views/invoice/InvoiceReport.vue";
import ReceiveReport from "@/views/invoice/ReceiveReport.vue";
import SOforInvoice from "@/views/invoice/SOforInvoice.vue";
import Newinvoice from "@/views/invoice/Newinvoice.vue";
import Newfreetextinvoice from "@/views/invoice/Newfreetextinvoice.vue";
import Editinvoice from "@/views/invoice/Editinvoice.vue";
import EditSo from "@/views/EditSo.vue";
import Company from "@/views/company.vue";
import Department from "@/views/department.vue";
import Position from "@/views/position.vue";
import Jobtitle from "@/views/jobtitle.vue";
import MyactivityOther from "@/views/myactivity.vue";
import Myactivity from "@/views/activity/myYourActivity.vue";
import myCheckInOut from "@/views/activity/myCheckInOut.vue";
import TimeAttendanceHistory from "@/views/activity/TimeAttendanceHistory.vue";
import MyDepactivity from "@/views/activity/myYourDepActivity.vue";
import NewActivityOther from "@/views/NewActivity.vue";
import NewActivity from "@/views/activity/newYoutActivity.vue";
import editActivity from "@/views/activity/editYoutActivity.vue";
import LeaveQuota from "@/views/LeaveQuota.vue";
import invTitle from "@/views/INV_Title.vue";
import approverManagement from "@/views/config/approverManagement.vue";
import approverManagementAdd from "@/views/config/approverManagementAdd.vue";
import advanceTitle from "@/views/advanceTitle.vue";
import invTitleADD from "@/views/INV_Title_Add.vue";

import PettyCashVoucher from "@/views/pettyCashVoucher/pettyCashVoucher.vue";
import PettyCashOper from "@/views/pettyCashVoucher/PettyCashOper.vue";
import AddPettyCashVoucher from "@/views/pettyCashVoucher/AddPettyCashVoucher.vue";
import ApprovePettyCash from "@/views/pettyCashVoucher/ApprovePettyCash.vue";
import ApproveAccount from "@/views/pettyCashVoucher/ApproveAccount.vue";

import ApproverLeave from "@/views/leave/ApproverLeave.vue";
import ApproverLeaveHistory from "@/views/leave/ApproverLeaveHistory.vue";
import LeaveHoliday from "@/views/leave/LeaveHoliday.vue";
import CompanyEvent from "@/views/leave/CompanyEvent.vue";
import LeaveHolidayImport from "@/views/leave/leaveHolidayImport.vue";
import companyEventImport from "@/views/leave/companyEventImport.vue";
import LeaveReport from "@/views/LeaveReport.vue";
import EditMyTimeSheet from "@/views/EditMyTimeSheet.vue";
import EditApproveTimeSheet from "@/views/EditApproveTimeSheet.vue";
import NewLeaveQuota from "@/views/NewLeaveQuota.vue";
import EditLeaveQuota from "@/views/EditLeaveQuota.vue";
import ImportLeaveQuota from "@/views/ImportLeaveQuota.vue";

import ApproveList from "@/views/leave/ApproveList.vue";
import ApproveLeaveConfirm from "@/views/leave/ApproveLeaveConfirm.vue";
import LeaveList from "@/views/leave/LeaveList.vue";
import LeaveTitle from "@/views/leave/leaveTitle.vue";
import LeaveRequest from "@/views/leave/LeaveRequest.vue";
import LeaveRequestEdit from "@/views/leave/LeaveRequestEdit.vue";
import LeaveRequestWaiting from "@/views/leave/LeaveRequestWaiting.vue";

import ResetPass from "@/views/accountManagement/ResetPass.vue";
import ForgotPass from "@/views/accountManagement/ForgotPass.vue";
import RegisterCompany from "@/views/accountManagement/RegisterCompany.vue";
import ForgotResetPass from "@/views/accountManagement/ForgotResetPass.vue";

import CreditNote from "@/views/invoice/CreditNote.vue";
import AddCreditNoteList from "@/views/invoice/AddCreditNoteList.vue";
import AddCreditNote from "@/views/invoice/AddCreditNote.vue";
import EditCreditNote from "@/views/invoice/EditCreditNote.vue";
import MiscellaneousList from "@/views/invoice/MiscellaneousList.vue";
import MiscellaneousListAdd from "@/views/invoice/MiscellaneousListAdd.vue";

import MasterList from "@/views/immigration/MasterList.vue";
import MasterAdd from "@/views/immigration/MasterAdd.vue";
import MasterEdit from "@/views/immigration/MasterEdit.vue";
import TransactionList from "@/views/immigration/TransactionList.vue";
import TransactionAdd from "@/views/immigration/TransactionAdd.vue";
import ImMasterPlaceofissueList from "@/views/immigration/ImMasterPlaceofissueList.vue";
import ImMasterPlaceofissueListAdd from "@/views/immigration/ImMasterPlaceofissueListAdd.vue";
import ImMasterWorkPlaceofissueList from "@/views/immigration/ImMasterWorkPlaceofissueList.vue";
import ImMasterWorkPlaceofissueListAdd from "@/views/immigration/ImMasterWorkPlaceofissueListAdd.vue";
import IMMatterList from "@/views/immigration/MatterList.vue";
import IMMatterAdd from "@/views/immigration/MatterAdd.vue";
import IMMatterEdit from "@/views/immigration/MatterEdit.vue";
import IMDocketList from "@/views/immigration/DocketList.vue";
import IMDocketAdd from "@/views/immigration/DocketAdd.vue";
import IMDocketEdit from "@/views/immigration/DocketEdit.vue";

import TransactionLogList from "@/views/loglist/TransactionLogList.vue";
import LogInOutLogList from "@/views/loglist/LogInOutLogList.vue";

import DocumentSetup from "@/views/DocumentSetup.vue";
import DocumentSetupAdd from "@/views/DocumentSetupAdd.vue";
import DocumentSetupAddTitle from "@/views/DocumentSetupAddTitle.vue";
import DocumentSetupEdit from "@/views/DocumentSetupEdit.vue";
import TransactionEdit from "@/views/immigration/TransactionEdit.vue";

import DDocument from "@/views/dDocument/ddocumentlist.vue";
import DDocumentAdd from "@/views/dDocument/ddocumentadd.vue";
import DDocumentEdit from "@/views/dDocument/ddocumentedit.vue";

import AdjustInvoiceList from "@/views/invoice/AdjustInvoiceList.vue";
import AdjustInvoice from "@/views/invoice/AdjustInvoice.vue";

import ImCaseTypeList from "@/views/immigration/ImCaseTypeList.vue";
import ImCaseTypeAdd from "@/views/immigration/ImCaseTypeAdd.vue";

///---------ip at law route ---------------------///

import MappingList from "@/views/ip-at-law-frontend/menuconfig/MappingList.vue";
import AddKeyWord from "@/views/ip-at-law-frontend/menuconfig/AddKeyword.vue";
import EditKeyWord from "@/views/ip-at-law-frontend/menuconfig/EditKeyword.vue";
import ShowKeyWord from "@/views/ip-at-law-frontend/menuconfig/ShowKeyword.vue";

import POA from "@/views/ip-at-law-frontend/contact/poa.vue";
import MasterTradeMarkList from "@/views/ip-at-law-frontend/mastertrademark/MasterTradeMarkList.vue";
import MasterTradeMarkAdd from "@/views/ip-at-law-frontend/mastertrademark/MasterTradeMarkNew.vue";
import MasterTradeMarkEdit from "@/views/ip-at-law-frontend/mastertrademark/MasterTradeMarkEditNew.vue";
import MasterPatentList from "@/views/ip-at-law-frontend/MasterPatentList/MasterPatentList.vue";
import MasterPatentAdd from "@/views/ip-at-law-frontend/MasterPatentList/MasterPatentAdd.vue";
import MasterPatentNew from "@/views/ip-at-law-frontend/MasterPatentList/MasterPatentNew.vue";
import MasterPatentEdit from "@/views/ip-at-law-frontend/MasterPatentList/MasterPatentEdit.vue";
import newMasterPatentEdit from "@/views/ip-at-law-frontend/MasterPatentList/newMasterPatentEdit.vue";
import TimeLineShow from "@/views/ip-at-law-frontend/MasterPatentList/TimeLineShow.vue";

import AppointmentList from "@/views/ip-at-law-frontend/appointment/AppointmentList.vue";
import AppointmentAdd from "@/views/ip-at-law-frontend/appointment/AppointmentNew.vue";
// import AppointmentEdit from "@/views/ip-at-law-frontend/appointment/AppointmentEdit.vue";
import AppointmentEdit from "@/views/ip-at-law-frontend/appointment/AppointmentEditNew.vue";
import AppointmentImport from "@/views/ip-at-law-frontend/appointment/AppointmentImport.vue";

import AppointmentPatentList from "@/views/ip-at-law-frontend/appointmentPatent/AppointmentPatent.vue";
import AppointmentPatentOperation from "@/views/ip-at-law-frontend/appointmentPatent/AppointmentPatentOperation.vue";
import AppointmentPatentNew from "@/views/ip-at-law-frontend/appointmentPatent/AppointmentPatentNew.vue";
import AppointmentPatentEdit from "@/views/ip-at-law-frontend/appointmentPatent/AppointmentPatentEditNew.vue";
import AppointmentPatentImport from "@/views/ip-at-law-frontend/appointmentPatent/AppointmentpatentImport.vue";

import CoverReportTM from "@/views/ip-at-law-frontend/coverreporttm/CoverReportTM.vue";
import CoverReportPT from "@/views/ip-at-law-frontend/coverreportpt/CoverReportPT.vue";

// import pdfDraw from "@/views/ip-at-law-frontend/pdfManagement/pdfDraw.vue";
// import editPDF from "@/views/pdfManagement/editPDF.html";'

import ImportTrademark from "@/views/ip-at-law-frontend/import_ocr/ImportTrademark.vue";
import ImportPatent from "@/views/ip-at-law-frontend/import_ocr/ImportPatent.vue";

import ContactList from "@/views/ip-at-law-frontend/contact/ContactList.vue";
import workType from "@/views/ip-at-law-frontend/workType.vue";

import IPPricelist from "@/views/IPPriceList/IPPricelist.vue";
import IPPriceAdd from "@/views/IPPriceList/IPPriceAdd.vue";

import PrivacyPolicy from "@/views/PrivacyPolicy.vue";

import TestBarChart from "../views/apexcharts/TestBarChart.vue";

import ClientAdd from "../views/clientDirectory/ClientAdd.vue";
import ClientEdit from "../views/clientDirectory/ClientEdit.vue";

import TestPDFMake from "../views/pdfMake/TestPDFMake.vue";
import TestPDFMake2 from "../views/pdfMake/TestPDFMake2.vue";
import Statementpdf from "../views/pdfMake/Statementpdf.vue";
import StatementpdfV2 from "../views/pdfMake/StatementpdfV2.vue";
import StatementpdfV3 from "../views/pdfMake/StatementpdfV3.vue";
import ReceiptInvoicePDF from "../views/pdfMake/ReceiptInvoicePDF.vue";
import CreditNotePDF from "../views/pdfMake/CreditNotePDF.vue";

import EmployeeTimeattendanceReport from "@/views/report/EmployeeTimeattendanceReport.vue";
import EmployeeActivityReport from "@/views/report/EmployeeActivityReport.vue";
import ClientWorkReport from "@/views/report/ClientWorkReport.vue";
import DepartmentActivityReport from "@/views/report/DepartmentActivityReport.vue";

import SectionAccessConfig from "@/views/config/SectionAccessConfig.vue";
import ClientTimeLine from "@/views/timeline/clientTimeLine.vue";
import ClientTimeLineStatus from "@/views/timeline/clientTimeLineStatus.vue";
import ClientTimeLineStatusConFig from "@/views/timeline/clientTimeLineStatusConFig.vue";
import DisputeResolutionDocket from "@/views/Litigation/DisputeResolutionDocket.vue";
import Litigationcourt from "@/views/Litigation/Litigationcourt.vue";
import Litigationcourtdepartment from "@/views/Litigation/Litigationcourtdepartment.vue";
import Litigationcourtlevel from "@/views/Litigation/Litigationcourtlevel.vue";
import Litigationcourtcasetype from "@/views/Litigation/Litigationcourtcasetype.vue";
import Litigationcourtstatus from "@/views/Litigation/Litigationcourtstatus.vue";
import DisputeResolutionOverview from "@/views/Litigation/DisputeResolutionOverview.vue";

import IncorporateMatterList from "@/views/incorporate/IncorporateMatterList.vue";
import IncorporateMatterEntitySelect from "@/views/incorporate/IncorporateMatterEntitySelect.vue";
import IncorporateMatterAdd from "@/views/incorporate/IncorporateMatterAdd.vue";
import IncorporateDocketList from "@/views/incorporate/IncorporateDocketList.vue";
import IncorporateMatterView from "@/views/incorporate/IncorporateMatterView.vue";
import IncorporateMatterEdit from "@/views/incorporate/IncorporateMatterEdit.vue";
// ⭐ เพิ่ม 3 บรรทัดนี้ — Docket Add / View / Edit
import IncorporateDocketAdd from "@/views/incorporate/IncorporateDocketAdd.vue";
import IncorporateDocketView from "@/views/incorporate/IncorporateDocketView.vue";
import IncorporateDocketEdit from "@/views/incorporate/IncorporateDocketEdit.vue";
import IncorporateOverview from "@/views/incorporate/IncorporateOverview.vue";

import QuotationList from "@/views/Quotation/Quotationlist.vue";
import QuotationForm from "@/views/Quotation/QuotationForm.vue";
import QuotationView from "@/views/Quotation/QuotationView.vue";
import AdjustQuotations from "@/views/Quotation/AdjustQuotations.vue";
import AdjustQuotationsEdit from "@/views/Quotation/AdjustQuotationsEdit.vue";

import ForgotPasswordFlow from "@/views/accountManagement/ForgotPasswordFlow.vue";
import IMOverview from "@/views/immigration/Overview.vue";

import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(VueRouter);

const routes = [
  {
    path: "/immigration-overview",
    meta: {
      isSecured: false,
    },
    name: "Immigration Overview",
    component: IMOverview,
  },
  {
    path: "/incorporate-overview",
    meta: { isSecured: false },
    name: "IncorporateOverview",
    component: IncorporateOverview,
  },
  {
    path: "/incorporate-matter-view/:id",
    meta: { isSecured: false },
    name: "IncorporateMatterView",
    component: IncorporateMatterView,
  },
  {
    path: "/incorporate-matter-edit/:id",
    meta: { isSecured: false },
    name: "IncorporateMatterEdit",
    component: IncorporateMatterEdit,
  },

  {
    path: "/incorporate-matter-list",
    meta: { isSecured: false },
    name: "IncorporateMatterList",
    component: IncorporateMatterList,
  },
  {
    path: "/incorporate-matter-entity-select",
    meta: { isSecured: false },
    name: "IncorporateMatterEntitySelect",
    component: IncorporateMatterEntitySelect,
  },
  {
    path: "/incorporate-matter-add/:entity_type",
    meta: { isSecured: false },
    name: "IncorporateMatterAdd",
    component: IncorporateMatterAdd,
  },
  {
    path: "/incorporate-docket-list",
    meta: { isSecured: false },
    name: "IncorporateDocketList",
    component: IncorporateDocketList,
  },
  // ⭐ เพิ่ม 3 route นี้ — Docket Add / View / Edit
  {
    path: "/incorporate-docket-add",
    meta: { isSecured: false },
    name: "IncorporateDocketAdd",
    component: IncorporateDocketAdd,
  },
  {
    path: "/incorporate-docket-view/:id",
    meta: { isSecured: false },
    name: "IncorporateDocketView",
    component: IncorporateDocketView,
  },
  {
    path: "/incorporate-docket-edit/:id",
    meta: { isSecured: false },
    name: "IncorporateDocketEdit",
    component: IncorporateDocketEdit,
  },
  {
    path: "/department-activity-report",
    name: "DepartmentActivityReport",
    component: DepartmentActivityReport,
  },
  {
    path: "/client-work-report",
    name: "ClientWorkReport",
    component: ClientWorkReport,
  },
  {
    path: "/employee-activity-report",
    name: "EmployeeActivityReport",
    component: EmployeeActivityReport,
  },
  {
    path: "/section-access-config",
    name: "SectionAccessConfig",
    component: SectionAccessConfig,
  },
  {
    path: "/credit-note-pdf",
    name: "CreditNotePDF",
    component: CreditNotePDF,
  },
  {
    path: "/receipt-invoice-pdf",
    name: "ReceiptInvoicePDF",
    component: ReceiptInvoicePDF,
  },
  {
    path: "/client-view/case/:id",
    name: "ClientTimeLine",
    component: ClientTimeLine,
    meta: {
      layout: "blank",
    },
  },
  {
    path: "/employee-timeattendance-report",
    name: "EmployeeTimeattendanceReport",
    component: EmployeeTimeattendanceReport,
  },
  {
    path: "/statement-pdf-v3",
    name: "StatementPDFV3",
    component: StatementpdfV3,
  },
  {
    path: "/statement-pdf",
    name: "StatementPDF",
    component: Statementpdf,
  },
  {
    path: "/statement-pdf-v2",
    name: "StatementPDFV2",
    component: StatementpdfV2,
  },
  {
    path: "/test-pdf-make",
    name: "TestPDFMake",
    component: TestPDFMake,
  },
  {
    path: "/test-pdf-make-2",
    name: "TestPDFMake2",
    component: TestPDFMake2,
  },
  {
    path: "/client-add",
    name: "ClientAdd",
    component: ClientAdd,
  },
  {
    path: "/client-edit/:id",
    name: "ClientEdit",
    component: ClientEdit,
  },
  {
    path: "/test-bar-chart",
    name: "TestBarChart",
    component: TestBarChart,
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
  },
  {
    path: "/reset-password/:com_code/:id",
    name: "reset-password",
    component: ForgotResetPass,
  },
  {
    path: "/my-profile",
    name: "my-profile",
    component: ResetPass,
  },
  {
    path: "/approve-leave-confirm/:id/:employee_id",
    name: "approve-leave-confirm",
    component: ApproveLeaveConfirm,
  },
  {
    path: "/leave-holiday",
    name: "leave-holiday",
    component: LeaveHoliday,
  },
  {
    path: "/company-event",
    name: "CompanyEvent",
    component: CompanyEvent,
  },
  {
    path: "/leave-holiday-import",
    name: "leave-holiday-import",
    component: LeaveHolidayImport,
  },
  {
    path: "/company-event-import",
    name: "companyEventImport",
    component: companyEventImport,
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPasswordFlow,
  },
  {
    path: "/register-company",
    name: "Register Company",
    component: RegisterCompany,
  },
  {
    path: "/my-time-off",
    meta: {
      isSecured: false,
    },
    name: "My Time Off",
    component: LeaveList,
  },
  {
    path: "/approve-list",
    meta: {
      isSecured: false,
    },
    name: "approve-list",
    component: ApproveList,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
  },
  {
    path: "/calendar",
    name: "Calendar",
    component: Calendar,
  },
  {
    path: "/not-found",
    name: "notFound",
    component: notFound,
  },
  {
    path: "/test-system",
    name: "testSystem",
    component: testSystem,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  // {
  //   path: "/register/:tranning_id",
  //   name: "register",
  //   component: Register,
  // },
  {
    path: "/training-list",
    name: "TranningList",
    component: TranningList,
  },
  {
    path: "/training-add",
    name: "TranningAdd",
    component: TranningAdd,
  },
  {
    path: "/training-edit/:id",
    name: "TranningEdit",
    component: TranningEdit,
  },
  {
    path: "/stock",
    name: "stock",
    component: Stock,
  },
  {
    path: "/stock-create",
    name: "stock-create",
    component: StockCreate,
  },
  {
    path: "/stock-edit/:id",
    name: "stock-edit",
    component: StockEdit,
  },
  {
    path: "/report",
    meta: {
      isSecured: true,
    },
    name: "report",
    component: Report,
  },
  {
    path: "/about",
    meta: {
      isSecured: false,
    },
    name: "about",
    component: About,
  },
  {
    path: "/employee",
    meta: {
      isSecured: false,
    },
    name: "employee",
    component: Employee,
  },
  {
    path: "/customer",
    meta: {
      isSecured: false,
    },
    name: "customer",
    component: Customer,
  },
  {
    path: "/config",
    meta: {
      isSecured: false,
    },
    name: "config",
    component: Config,
  },
  {
    path: "/roleconfig",
    meta: {
      isSecured: false,
    },
    name: "roleconfig",
    component: RoleConfig,
  },
  {
    path: "/group-menu",
    meta: {
      isSecured: false,
    },
    name: "group-menu",
    component: GroupMenu,
  },
  {
    path: "/doc-running",
    meta: {
      isSecured: false,
    },
    name: "doc-running",
    component: Docrunning,
  },
  {
    path: "/menu-detail",
    meta: {
      isSecured: false,
    },
    name: "menu-detail",
    component: MenuDetail,
  },
  {
    path: "/access-control",
    meta: {
      isSecured: false,
    },
    name: "access-control",
    component: SettingGroupMenu,
  },
  {
    path: "/setting-menu-detail/:id",
    meta: {
      isSecured: false,
    },
    name: "setting-menu-detail",
    component: SettingMenuDetail,
  },
  {
    path: "/so-list",
    meta: {
      isSecured: false,
    },
    name: "so-list",
    component: SoList,
  },
  {
    path: "/add-so",
    meta: {
      isSecured: false,
    },
    name: "add-so",
    component: AddSo,
  },
  {
    path: "/advance-list",
    meta: {
      isSecured: false,
    },
    name: "advance-list",
    component: Advancelist,
  },
  {
    path: "/new-advance",
    alias: ["/new-advance/:id"],
    meta: {
      isSecured: false,
    },
    name: "new-advance",
    component: NewAdvance,
  },
  {
    path: "/edit-advance/:id/:mode",
    alias: ["/edit-advance"],
    meta: {
      isSecured: false,
    },
    name: "edit-advance",
    component: EditAdvance,
  },
  {
    path: "/approve-advance/:id/:mode",
    alias: ["/approve-advance"],
    meta: {
      isSecured: false,
    },
    name: "approve-advance",
    component: ApproveAdvance,
  },
  {
    path: "/clearadvance-list",
    meta: {
      isSecured: false,
    },
    name: "clearadvance-list",
    component: ClearAdvancelist,
  },
  {
    path: "/clearadvance-add/:id",
    meta: {
      isSecured: false,
    },
    name: "clearadvance-add",
    component: ClearAdvanceadd,
  },
  {
    path: "/approve-advance-list",
    meta: {
      isSecured: false,
    },
    name: "approve-advance-list",
    component: ApproveAdvancelist,
  },
  {
    path: "/account-pending-advance-list",
    meta: {
      isSecured: false,
    },
    name: "account-pending-advance-list",
    component: AccountPendingAdvancelist,
  },
  {
    path: "/account-clear-advance-list",
    meta: {
      isSecured: false,
    },
    name: "account-clear-advance-list",
    component: AccountClearAdvancelist,
  },
  {
    path: "/account-reporting-advance-list",
    meta: {
      isSecured: false,
    },
    name: "account-reporting-advance-list",
    component: AccountReportingAdvancelist,
  },
  {
    path: "/account-pending-advance/:id",
    meta: {
      isSecured: false,
    },
    name: "account-pending-advance",
    component: AccountPendingAdvance,
  },
  {
    path: "/account-clear-advance/:id",
    meta: {
      isSecured: false,
    },
    name: "account-clear-advance",
    component: AccountClearAdvance,
  },
  {
    path: "/my-time-sheet",
    meta: {
      isSecured: false,
    },
    name: "my-time-sheet",
    component: MyTimeSheet,
  },
  {
    path: "/approve-time-sheet",
    meta: {
      isSecured: false,
    },
    name: "approve-time-sheet",
    component: ApproveTimeSheet,
  },
  {
    path: "/summary-timesheets-activity-report",
    meta: {
      isSecured: false,
    },
    name: "summary-timesheet-activity-Report",
    component: SummaryTimeActivityReport,
  },
  {
    path: "/activity-report",
    meta: {
      isSecured: false,
    },
    name: "activity-report",
    component: SummaryReport,
  },
  {
    path: "/client-timesheet-report",
    meta: {
      isSecured: false,
    },
    name: "Client Summary Report",
    component: ClientSummaryReport,
    children: [
      {
        path: ":timesheet_no",
        name: "Client Summary Report Detail",
        props: true,
      },
    ],
  },
  {
    path: "/report-detail-time-sheet",
    meta: {
      isSecured: false,
    },
    name: "Report Detail Time Sheet",
    component: EmployeeAttendentSummaryReport,
  },
  {
    path: "/employee-timesheet-report",
    meta: {
      isSecured: false,
    },
    name: "Employee Summary Report",
    component: EmployeeSummaryReport,
  },
  {
    path: "/attendant-report",
    meta: {
      isSecured: false,
    },
    name: "Attendant Report",
    component: AttendantReport,
  },
  {
    path: "/edit-so/:id",
    meta: {
      isSecured: false,
    },
    name: "edit-so",
    component: EditSo,
  },
  {
    path: "/invoice",
    meta: {
      isSecured: false,
    },
    name: "invoice",
    component: Invoice,
  },
  {
    path: "/adjust-invoice",
    meta: {
      isSecured: false,
    },
    name: "Adjust Invoice List",
    component: AdjustInvoiceList,
  },
  {
    path: "/adjust-invoice-edit/:id",
    meta: {
      isSecured: false,
    },
    name: "Adjust Invoice",
    component: AdjustInvoice,
  },

  {
    path: "/receive",
    meta: {
      isSecured: false,
    },
    name: "receive",
    component: Receive,
  },
  {
    path: "/adjust-receipt",
    meta: {
      isSecured: false,
    },
    name: "AdjustReceive",
    component: AdjustReceive,
  },
  {
    path: "/receive-select-document/:company_inv",
    meta: {
      isSecured: false,
    },
    name: "Receive Select Document",
    component: ReceiveSelectDocument,
  },
  {
    path: "/receive-edit/:id",
    meta: {
      isSecured: false,
    },
    name: "Receive Edit",
    component: ReceiveEdit,
  },
  {
    path: "/receive-adjsut-edit/:id",
    meta: {
      isSecured: false,
    },
    name: "Receive Adjsut Edit",
    component: ReceiveAdjustEdit,
  },
  {
    path: "/receive-confirm/:company_inv/:customer_id/:id",
    meta: {
      isSecured: false,
    },
    name: "Receive Confirm",
    component: ReceiveConfirm,
  },
  {
    path: "/invoice-report",
    meta: {
      isSecured: false,
    },
    name: "invoice-report",
    component: InvoiceReport,
  },
  {
    path: "/receipt-report",
    meta: {
      isSecured: false,
    },
    name: "receipt-report",
    component: ReceiveReport,
  },
  {
    path: "/sales-outstanding",
    meta: {
      isSecured: false,
    },
    name: "sales-outstanding",
    component: SalesOutstanding,
  },
  {
    path: "/sales-report",
    meta: {
      isSecured: false,
    },
    name: "sales-report",
    component: SalesReport,
  },
  {
    path: "/company",
    meta: {
      isSecured: false,
    },
    name: "company",
    component: Company,
  },
  {
    path: "/department",
    meta: {
      isSecured: false,
    },
    name: "department",
    component: Department,
  },
  {
    path: "/position",
    meta: {
      isSecured: false,
    },
    name: "position",
    component: Position,
  },
  {
    path: "/jobtitle",
    meta: {
      isSecured: false,
    },
    name: "jobtitle",
    component: Jobtitle,
  },
  {
    path: "/my-activity",
    meta: {
      isSecured: false,
    },
    name: "My Activity",
    component: Myactivity,
  },
  {
    path: "/my-attendance-history",
    meta: {
      isSecured: false,
    },
    name: "My Attendance History",
    component: myCheckInOut,
  },
  {
    path: "/time-attendance-history",
    meta: {
      isSecured: false,
    },
    name: "Time Attendance History",
    component: TimeAttendanceHistory,
  },
  {
    path: "/create-activity-to-timesheet",
    meta: {
      isSecured: false,
    },
    name: "My Activity To Timesheet",
    component: MyactivityOther,
  },
  {
    path: "/department-activity",
    meta: {
      isSecured: false,
    },
    name: "My Activity Department",
    component: MyDepactivity,
  },
  {
    path: "/new-activity",
    meta: {
      isSecured: false,
    },
    name: "New Employee Activity",
    component: NewActivity,
  },
  {
    path: "/new-employee-activity",
    meta: {
      isSecured: false,
    },
    name: "New Activity Other",
    component: NewActivityOther,
  },
  {
    path: "/edit-activity/:id",
    meta: {
      isSecured: false,
    },
    name: "Edit Activity",
    component: editActivity,
  },
  {
    path: "/leave-quota",
    meta: {
      isSecured: false,
    },
    name: "Leave Quota",
    component: LeaveQuota,
  },
  {
    path: "/document-setup",
    meta: {
      isSecured: false,
    },
    name: "Document Setup",
    component: DocumentSetup,
  },
  {
    path: "/document-setup-add",
    meta: {
      isSecured: false,
    },
    name: "Document Setup Add",
    component: DocumentSetupAdd,
  },
  {
    path: "/document-setup-title/:mode/:doctype_id",
    meta: {
      isSecured: false,
    },
    name: "Document Setup Add Title",
    component: DocumentSetupAddTitle,
  },
  {
    path: "/document-setup-edit/:doctype_id",
    meta: {
      isSecured: false,
    },
    name: "Document Setup Edit",
    component: DocumentSetupEdit,
  },
  {
    path: "/leave-request",
    meta: {
      isSecured: false,
    },
    name: "Leave Request",
    component: LeaveRequest,
  },
  {
    path: "/leave-request-edit/:id",
    meta: {
      isSecured: false,
    },
    name: "Leave Request Edit",
    component: LeaveRequestEdit,
  },
  {
    path: "/leave-request-waiting/:id/:mode",
    meta: {
      isSecured: false,
    },
    name: "Leave Request Waiting",
    component: LeaveRequestWaiting,
  },
  {
    path: "/approver-time-off",
    meta: {
      isSecured: false,
    },
    name: "Approve Time Off",
    component: ApproverLeave,
  },
  {
    path: "/approver-time-off-history",
    meta: {
      isSecured: false,
    },
    name: "Approve Time Off History",
    component: ApproverLeaveHistory,
  },
  {
    path: "/leave-report",
    meta: {
      isSecured: false,
    },
    name: "Leave Report",
    component: LeaveReport,
  },
  {
    path: "/edit-mytimesheet/:id",
    meta: {
      isSecured: false,
    },
    name: "Edit My TimeSheet",
    component: EditMyTimeSheet,
  },
  {
    path: "/edit-approvetimesheet/:id",
    meta: {
      isSecured: false,
    },
    name: "Edit Approve TimeSheet",
    component: EditApproveTimeSheet,
  },
  {
    path: "/new-leave-quota",
    meta: {
      isSecured: false,
    },
    name: "New Leave Quota",
    component: NewLeaveQuota,
  },
  {
    path: "/edit-leave-quota/:id/:period_datefrom/:period_dateto",
    meta: {
      isSecured: false,
    },
    name: "Edit Leave Quota",
    component: EditLeaveQuota,
  },
  {
    path: "/import-leave-quota",
    meta: {
      isSecured: false,
    },
    name: "Import Leave Quota",
    component: ImportLeaveQuota,
  },
  {
    path: "/approver-management",
    meta: {
      isSecured: false,
    },
    name: "Approver Management",
    component: approverManagement,
  },
  {
    path: "/approver-management-setting/:id",
    meta: {
      isSecured: false,
    },
    name: "Approver Management Setting",
    component: approverManagementAdd,
  },
  {
    path: "/invoice-title",
    meta: {
      isSecured: false,
    },
    name: "Invoice Title",
    component: invTitle,
  },
  {
    path: "/advance-type",
    meta: {
      isSecured: false,
    },
    name: "Advance Type",
    component: advanceTitle,
  },
  {
    path: "/invioce-title-add/:mode/:id",
    meta: {
      isSecured: false,
    },
    name: "Invoice Title Add",
    component: invTitleADD,
  },
  {
    path: "/leave-type",
    meta: {
      isSecured: false,
    },
    name: "Leave Type",
    component: LeaveTitle,
  },
  {
    path: "/so-for-invoice/:company_inv",
    meta: {
      isSecured: false,
    },
    name: "SalseOrder For Invoice",
    component: SOforInvoice,
  },
  {
    path: "/new-free-invoice/:id/:mode/:company_inv",
    meta: {
      isSecured: false,
    },
    children: [
      {
        path: ":customer_id/:menurequest",
        name: "New Invoice Free Text",
        props: true,
      },
    ],
    name: "New Free Invoice",
    component: Newfreetextinvoice,
  },
  {
    path: "/new-invoice/:id/:mode/:company_inv",
    meta: {
      isSecured: false,
    },
    name: "New Invoice",
    component: Newinvoice,
  },
  {
    path: "/edit-invoice/:id/:mode/:company_inv",
    meta: {
      isSecured: false,
    },
    name: "Edit Invoice",
    component: Editinvoice,
  },
  {
    path: "/credit-note",
    meta: {
      isSecured: false,
    },
    name: "Credit Note",
    component: CreditNote,
  },
  {
    path: "/add-credit-note-list",
    meta: {
      isSecured: false,
    },
    name: "Add CreditNote List",
    component: AddCreditNoteList,
  },
  {
    path: "/add-credit-note/:id",
    meta: {
      isSecured: false,
    },
    name: "Add CreditNote",
    component: AddCreditNote,
  },
  {
    path: "/edit-credit-note/:id",
    meta: {
      isSecured: false,
    },
    name: "Edit CreditNote",
    component: EditCreditNote,
  },
  {
    path: "/immigration-master",
    meta: {
      isSecured: false,
    },
    name: "Master List",
    component: MasterList,
  },
  {
    path: "/transaction-log-list",
    meta: {
      isSecured: false,
    },
    name: "Transaction Log List",
    component: TransactionLogList,
  },
  {
    path: "/log-in-out-log-list",
    meta: {
      isSecured: false,
    },
    name: "Log in out Log List",
    component: LogInOutLogList,
  },
  {
    path: "/immigration-master-add",
    meta: {
      isSecured: false,
    },
    name: "Master Add",
    component: MasterAdd,
  },
  {
    path: "/immigration-transaction-add/",
    meta: {
      isSecured: false,
    },
    name: "Transaction Add",
    component: TransactionAdd,
    children: [
      {
        path: ":file_no",
        name: "Transaction Add Detail",
        props: true,
      },
    ],
  },
  {
    path: "/immigration-master-edit/:id",
    meta: {
      isSecured: false,
    },
    name: "Master Edit",
    component: MasterEdit,
  },
  {
    path: "/immigration-service",
    meta: {
      isSecured: false,
    },
    name: "Transaction List",
    component: TransactionList,
  },
  {
    path: "/immigration-transaction-edit/:id",
    meta: {
      isSecured: false,
    },
    name: "Immigration Transaction Edit",
    component: TransactionEdit,
  },

  {
    path: "/immigration-matter",
    meta: {
      isSecured: false,
    },
    name: "Matter List",
    component: IMMatterList,
  },
  {
    path: "/immigration-matter-add",
    meta: {
      isSecured: false,
    },
    name: "Matter Add",
    component: IMMatterAdd,
  },
  {
    path: "/immigration-matter-edit/:id",
    meta: {
      isSecured: false,
    },
    name: "Matter Edit",
    component: IMMatterEdit,
  },

  {
    path: "/immigration-docket",
    meta: {
      isSecured: false,
    },
    name: "Docket List",
    component: IMDocketList,
  },
  {
    path: "/immigration-docket-add",
    meta: {
      isSecured: false,
    },
    name: "Docket Add",
    component: IMDocketAdd,
  },
  {
    path: "/immigration-docket-edit/:id",
    meta: {
      isSecured: false,
    },
    name: "Docket Edit",
    component: IMDocketEdit,
  },

  {
    path: "/d-document",
    meta: {
      isSecured: false,
    },
    name: "D-Document",
    component: DDocument,
    children: [
      {
        path: ":id",
        name: "D-Document Detail",
        props: true,
      },
    ],
  },
  {
    path: "/d-document-add/:mode/:doctype_id",
    meta: {
      isSecured: false,
    },
    name: "D-Document Add",
    component: DDocumentAdd,
  },
  {
    path: "/d-document-operation/:mode/:doctype_id/:doctrans_hid",
    meta: {
      isSecured: false,
    },
    name: "D-Document Edit",
    component: DDocumentEdit,
  },
  {
    path: "/miscellaneous-list",
    meta: {
      isSecured: false,
    },
    name: "Miscellaneous List",
    component: MiscellaneousList,
  },
  {
    path: "/miscellaneous-list-add/:mode/:id",
    meta: {
      isSecured: false,
    },
    name: "Miscellaneous List Add",
    component: MiscellaneousListAdd,
  },
  {
    path: "/im-master-placeofissue-list",
    meta: {
      isSecured: false,
    },
    name: "Immigration Master Place of issue List",
    component: ImMasterPlaceofissueList,
  },
  {
    path: "/im-master-placeofissue-list-add/:mode/:id",
    meta: {
      isSecured: false,
    },
    name: "Immigration Master Place of issue List Add",
    component: ImMasterPlaceofissueListAdd,
  },
  {
    path: "/im-master-workplaceofissue-list",
    meta: {
      isSecured: false,
    },
    name: "Immigration Master Work Place of issue List",
    component: ImMasterWorkPlaceofissueList,
  },
  {
    path: "/im-master-workplaceofissue-list-add/:mode/:id",
    meta: {
      isSecured: false,
    },
    name: "Immigration Master Work Place of issue List Add",
    component: ImMasterWorkPlaceofissueListAdd,
  },
  {
    path: "/im-case-type-list",
    meta: {
      isSecured: false,
    },
    name: "Immigration Case Type List",
    component: ImCaseTypeList,
  },
  {
    path: "/im-case-type-add/:mode/:id",
    meta: {
      isSecured: false,
    },
    name: "Immigration Case Type Add",
    component: ImCaseTypeAdd,
  },

  ////-------------- ip at law router-------------------////
  {
    path: "/import-tm",
    name: "import-tm",
    component: ImportTrademark,
  },
  {
    path: "/import-pt",
    name: "import-pt",
    component: ImportPatent,
  },
  // {
  //   path: "/pdfDraw",
  //   name: "pdfDraw",
  //   component: pdfDraw,
  // },
  {
    path: "/mapping-keyword",
    meta: {
      isSecured: false,
    },
    name: "mapping-keyword",
    component: MappingList,
  },
  {
    path: "/new-keyword",
    meta: {
      isSecured: false,
    },
    name: "new-keyword",
    component: AddKeyWord,
  },
  {
    path: "/edit-keyword/:mode/:doctype_id/:notice_id",
    meta: {
      isSecured: false,
    },
    name: "edit-keyword",
    component: EditKeyWord,
  },
  {
    path: "/show-keyword/:mode/:doctype_id/:notice_id",
    meta: {
      isSecured: false,
    },
    name: "show-keyword",
    component: ShowKeyWord,
  },
  {
    path: "/contact-list",
    meta: {
      isSecured: false,
    },
    name: "ContactList",
    component: ContactList,
  },
  {
    path: "/work-type-list",
    meta: {
      isSecured: false,
    },
    name: "workType",
    component: workType,
  },
  {
    path: "/ip-price-list",
    meta: {
      isSecured: false,
    },
    name: "IP Price List",
    component: IPPricelist,
  },
  {
    path: "/ip-price-add",
    meta: {
      isSecured: false,
    },
    name: "IP Price Add",
    component: IPPriceAdd,
  },
  {
    path: "/ip-price-edit/:id",
    meta: {
      isSecured: false,
    },
    name: "IP Price Edit",
    component: IPPriceAdd,
  },
  {
    path: "/poa/:id",
    meta: {
      isSecured: false,
    },
    name: "POA",
    component: POA,
  },
  {
    path: "/master-trademark-list",
    meta: {
      isSecured: false,
    },
    name: "MasterTradeMarkList",
    component: MasterTradeMarkList,
  },
  {
    path: "/master-patent-list",
    meta: {
      isSecured: false,
    },
    name: "MasterPatentList",
    component: MasterPatentList,
  },
  {
    path: "/master-patent-add",
    meta: {
      isSecured: false,
    },
    name: "MasterPatentAdd",
    component: MasterPatentAdd,
  },
  {
    path: "/new-master-patent",
    meta: {
      isSecured: false,
    },
    name: "MasterPatentNew",
    component: MasterPatentNew,
  },
  {
    path: "/master-patent-edit/:masterpt_id",
    meta: {
      isSecured: false,
    },
    name: "MasterPatentEdit",
    component: MasterPatentEdit,
  },
  {
    path: "/master-patent-edit-new/:masterpt_id",
    meta: {
      isSecured: false,
    },
    name: "newMasterPatentEdit",
    component: newMasterPatentEdit,
  },
  {
    path: "/timeline-master-patent/:masterpt_id",
    meta: {
      isSecured: false,
    },
    name: "TimeLineShow",
    component: TimeLineShow,
  },
  {
    path: "/appointment-patent-list",
    meta: {
      isSecured: false,
    },
    name: "AppointmentPatentList",
    component: AppointmentPatentList,
  },
  {
    path: "/appointment-patent-add",
    meta: {
      isSecured: false,
    },
    name: "AppointmentPatentAdd",
    component: AppointmentPatentOperation,
    children: [
      {
        path: ":file_no",
        name: "AppointmentPatentAddDetail",
        props: true,
      },
    ],
  },
  {
    path: "/appointment-patent-new",
    meta: {
      isSecured: false,
    },
    name: "AppointmentPatentNew",
    component: AppointmentPatentNew,
    children: [
      {
        path: ":file_no",
        name: "AppointmentPatentAddNew",
        props: true,
      },
    ],
  },
  {
    path: "/appointment-patent-edit/:appointment_id",
    meta: {
      isSecured: false,
    },
    name: "AppointmentPatentEdit",
    component: AppointmentPatentEdit,
  },
  {
    path: "/appointment-patent-import",
    meta: {
      isSecured: false,
    },
    name: "AppointmentPatentImport",
    component: AppointmentPatentImport,
  },
  {
    path: "/appointment-trademark-list",
    meta: {
      isSecured: false,
    },
    name: "AppointmentList",
    component: AppointmentList,
  },
  {
    path: "/master-trademark-add",
    meta: {
      isSecured: false,
    },
    name: "MasterTradeMarkAdd",
    component: MasterTradeMarkAdd,
  },
  {
    path: "/master-trademark-edit/:mastertm_id",
    meta: {
      isSecured: false,
    },
    name: "MasterTradeMarkEdit",
    component: MasterTradeMarkEdit,
  },
  {
    path: "/appointmenttm-add/",
    meta: {
      isSecured: false,
    },
    name: "AppointmentAdd",
    component: AppointmentAdd,
    children: [
      {
        path: ":file_no/:date_of_renewal",
        name: "AppointmentAddDetail",
        props: true,
      },
    ],
  },
  {
    path: "/appointmenttm-edit/:appointment_id",
    meta: {
      isSecured: false,
    },
    name: "AppointmentEdit",
    component: AppointmentEdit,
  },
  {
    path: "/appointment-import",
    meta: {
      isSecured: false,
    },
    name: "AppointmentImport",
    component: AppointmentImport,
  },
  {
    path: "/cover-report-tm",
    meta: {
      isSecured: false,
    },
    name: "CoverReportTM",
    component: CoverReportTM,
  },
  {
    path: "/cover-report-pt",
    meta: {
      isSecured: false,
    },
    name: "CoverReportPT",
    component: CoverReportPT,
  },
  {
    path: "/petty-cash-voucher",
    meta: {
      isSecured: false,
    },
    name: "PettyCashVoucher",
    component: PettyCashVoucher,
  },
  {
    path: "/petty-cash/:mode/:id",
    meta: {
      isSecured: false,
    },
    name: "PettyCashOper",
    component: PettyCashOper,
  },
  {
    path: "/add-petty-cash",
    meta: {
      isSecured: false,
    },
    name: "AddPettyCashVoucher",
    component: AddPettyCashVoucher,
  },
  {
    path: "/approve-petty-cash",
    meta: {
      isSecured: false,
    },
    name: "ApprovePettyCash",
    component: ApprovePettyCash,
  },
  {
    path: "/approve-account-petty-cash",
    meta: {
      isSecured: true,
    },
    name: "ApproveAccount",
    component: ApproveAccount,
  },
  {
    path: "/client-timeline-status",
    meta: {
      isSecured: true,
    },
    name: "ClientTimeLineStatus",
    component: ClientTimeLineStatus,
  },
  {
    path: "/client-timeline-status-config",
    meta: {
      isSecured: true,
    },
    name: "ClientTimeLineStatusConFig",
    component: ClientTimeLineStatusConFig,
  },
  {
    path: "/dispute-resolution-docket/:id",
    name: "DisputeResolutionDocket",
    component: DisputeResolutionDocket,
  },
  {
    path: "/litigation-court",
    name: "Litigationcourt",
    component: Litigationcourt,
  },
  {
    path: "/litigation-court-department",
    name: "Litigationcourtdepartment",
    component: Litigationcourtdepartment,
  },
  {
    path: "/litigation-court-level",
    name: "Litigationcourtlevel",
    component: Litigationcourtlevel,
  },
  {
    path: "/litigation-court-casetype",
    name: "Litigationcourtcasetype",
    component: Litigationcourtcasetype,
  },
  {
    path: "/litigation-court-status",
    name: "Litigationcourtstatus",
    component: Litigationcourtstatus,
  },
  {
    path: "/litigation-overview",
    name: "DisputeResolutionOverview",
    component: DisputeResolutionOverview,
  },
  // ⭐ เพิ่ม 4 route นี้ — Quotation / Fee Estimate
  {
    path: "/quotation-list",
    meta: { isSecured: false },
    name: "QuotationList",
    component: QuotationList,
  },
  {
    path: "/add-quotation",
    meta: { isSecured: false },
    name: "AddQuotation",
    component: QuotationForm,
  },
  {
    path: "/edit-quotation/:id",
    meta: { isSecured: false },
    name: "EditQuotation",
    component: QuotationForm,
  },
  {
    path: "/adjust-quotation",
    meta: { isSecured: false },
    name: "AdjustQuotations",
    component: AdjustQuotations,
  },
  {
    path: "/adjust-quotation-edit/:id",
    meta: { isSecured: false },
    name: "AdjustQuotationsEdit",
    component: AdjustQuotationsEdit,
  },
  {
    path: "/view-quotation/:id",
    meta: { isSecured: false },
    name: "ViewQuotation",
    component: QuotationView,
  },
  //-----------------------------end-----------------//
  {
    path: "*",
    redirect: "/dashboard",
  },
];

Vue.use(VueLoading, {
  color: "green",
  loader: "dots",
  canCancel: false,
  width: 120,
  height: 120,
  backgroundColor: "#ffffff",
  opacity: 0.5,
  zIndex: 999,
});
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // history: VueRouter.createWebHashHistory(),
  routes,
});

let loader = null;

function hideLoader() {
  // destroy previous
  if (loader) {
    loader.hide();
    loader = null;
  }
}

function showLoader() {
  hideLoader();
  loader = Vue.$loading.show();
}
// Vue.prototype.$showLoader = showLoader
// Vue.prototype.$hideLoader = hideLoader
router.beforeEach((to, from, next) => {
  if (to.name) {
    showLoader();
  }
  Vue.prototype.$showLoader = showLoader;
  Vue.prototype.$hideLoader = hideLoader;
  next();
});
router.afterEach((to, from) => {
  showLoader();
  // setTimeout(() => {
  //   window.location.href = "/not-found";
  //   loader.hide()
  // }, 15000)
});
export default router;
